import React from "react";
import { cn } from "@/lib/utils";

export function PowerballBall({ n, red = false, size = "md", testid, delay = 0 }) {
  const sizes = {
    xs: "w-7 h-7 text-[11px]",
    sm: "w-8 h-8 text-xs sm:w-9 sm:h-9 sm:text-sm",
    md: "w-10 h-10 text-sm sm:w-12 sm:h-12 sm:text-base",
    lg: "w-16 h-16 text-xl sm:w-20 sm:h-20 sm:text-2xl",
  };
  return (
    <div
      data-testid={testid}
      style={{ animationDelay: `${delay}ms` }}
      className={cn(
        "font-body font-bold flex items-center justify-center rounded-full border animate-reveal-up shrink-0",
        sizes[size],
        red
          ? "bg-pb_red text-white border-white/25 shadow-[0_0_18px_rgba(229,9,20,0.55)]"
          : "bg-parchment text-ink border-white/40 shadow-inner"
      )}
    >
      {String(n).padStart(2, "0")}
    </div>
  );
}
